<template>
  <div class="h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Process New Collection
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Select a collection code and add counts of Anophelines and other species
      </p>
    </b-container>

    <b-container fluid>
        <b-row>
            <b-col>
                <b-form-input
                    label="Collection Code"
                    placeholder="Start typing collection code to filter, or double click to get list."
                    v-model="form_data.collection_code_id"
                    list="cc-list"
                    size="lg"
                ></b-form-input>

                <datalist id="cc-list">
                    <option
                        v-for="cCode in getCodes"
                        :key="cCode.collection_code"
                    >
                        {{ cCode.collection_code }}
                    </option>
                </datalist>
            </b-col>
            <b-col cols="auto">
              <b-button @click="downloadCollectionCodeCountSummary()" block size="lg" variant="success">
                Mosquito Count
              </b-button>
            </b-col>
        </b-row>
    </b-container>

    <hr>

    <b-container class="m-0">
      <b-card>
        <b-container fluid>
          <b-row>
            <b-col class="tw-p-2">Species</b-col>
            <b-col class="tw-p-2">Unfed</b-col>
            <b-col class="tw-p-2">Fed</b-col>
            <b-col class="tw-p-2">Gravid</b-col>
            <b-col class="tw-p-2">Half-Gravid</b-col>
            <b-col class="tw-p-2">Male</b-col>
          </b-row>

          <b-row>
            <b-col class="tw-p-2">An. gambiae s.l.</b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.gambiae_unfed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.gambiae_fed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.gambiae_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.gambiae_half_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.gambiae_male"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="tw-p-2">An. funestus</b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.funestus_unfed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.funestus_fed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.funestus_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.funestus_half_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.funestus_male"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="tw-p-2">An. coustani</b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.coustani_unfed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.coustani_fed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.coustani_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.coustani_half_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.coustani_male"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="tw-p-2">Culex spp.</b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.culex_unfed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.culex_fed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.culex_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.culex_half_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.culex_male"
                required
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="tw-p-2">Other spp.</b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.other_unfed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.other_fed"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.other_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.other_half_gravid"
                required
              ></b-form-input>
            </b-col>
            <b-col class="tw-p-2">
              <b-form-input
                v-model="form_data.other_male"
                required
              ></b-form-input>
            </b-col>
          </b-row>
          <div class="text-center tw-mt-4">
            <b-btn variant="outline-primary" class="tw-mx-1">Clear</b-btn>
            <b-btn variant="primary" class="tw-mx-1" @click="save()"
              >Save</b-btn>
          </div>
        </b-container>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters, mapActions } from "vuex";

import { HTTP } from "@/utilities/http-common";
import HandleErrors from '@/utilities/handle-errors';

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      message: null,
      form_data: {
        collection_code_id: "",
        // anophs: 0,
        // culicines: 0,

        gambiae_unfed: 0,
        gambiae_fed: 0,
        gambiae_gravid: 0,
        gambiae_half_gravid: 0,
        gambiae_male: 0,

        funestus_unfed: 0,
        funestus_fed: 0,
        funestus_gravid: 0,
        funestus_half_gravid: 0,
        funestus_male: 0,

        coustani_unfed: 0,
        coustani_fed: 0,
        coustani_gravid: 0,
        coustani_half_gravid: 0,
        coustani_male: 0,

        culex_unfed: 0,
        culex_fed: 0,
        culex_gravid: 0,
        culex_half_gravid: 0,
        culex_male: 0,

        other_unfed: 0,
        other_fed: 0,
        other_gravid: 0,
        other_half_gravid: 0,
        other_male: 0,
      },
    };
  },
  mounted: function() {
    this.loadData();
  },
  computed: {
    ...mapState("websheet", ["newEntoCollectionModal", "entoCollectionCodes"]),
    ...mapGetters("websheet", ["getCodes"]),
  },
  watch: {
    // Variable is being watched here so that, when it is true (i.e. modal is shown), refresh the collection codes.
    newEntoCollectionModal(val) {
      if (val) {
        this.loadData();
      }
    },
  },
  methods: {
    ...mapActions("websheet", [
      "updateEntoCollectionModal",
      "setEntoCollectionCodes",
      "getEntoCollectionCodes",
    ]),

    cancel: function() {
      this.updateEntoCollectionModal(false);
    },
    save: function() {
      let that = this;
      that.message = null;
      if (!that.form_data.collection_code_id) {
        this.$notify({
          text: "Please select a collection code!",
          duration: 10000,
          type: "error",
        });
        return;
      }

      HTTP.post("/kenya/create-ento-data/", this.form_data)
        .then(() => {
        //   that.updateEntoCollectionModal(false);

        //   let collection = that.entoCollectionCodes.find(
        //     (coll) => coll.collection_code === that.form_data.collection_code_id
        //   );

          that.$router.push({
            name: "anoph-data",
            params: {
              templateId: "ento_its2",
            },
            query: {
              collectionCode: that.form_data.collection_code_id,
            },
          });
        })
        .catch((error) => {
          if ("message" in error.response.data) {
            that.message = error.response.data["message"];
          }
        });
    },
    loadData: function() {
      this.getEntoCollectionCodes('draft').then((response) => {
        _.each(response.data, function(item, index) {
          response.data[
            index
          ].text = `${response.data[index].collection_code}`;
        });

        this.setEntoCollectionCodes(response.data);
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    },
    downloadCollectionCodeCountSummary: function() {
      HTTP.get('/kenya/collection-code-mosquito-count-summary/').then(response => {
          var fileURL = window.URL.createObjectURL(
              new Blob([response.data])
          );
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "ento-collection-code-mosquito-count-summary.csv");
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    }
  },
};
</script>

<style></style>
